export const IOS_SETTINGS_ITEMS = [
  {
    key: 'provisioningProfile',
    count: 0,
    value: 'settings.ios_settings.csr_profile',
  },
  {
    key: 'webdriverAgent',
    count: 0,
    value: 'settings.ios_settings.web_agent',
  },
];

export const TABLE_HEADERS = [
  { value: 'settings.ios_settings.profile_name', class: 'w-[150px]' },
  { value: 'settings.ios_settings.apple.team_id', class: 'w-[150px]' },
  { value: 'settings.ios_settings.csr', class: 'w-[140px]' },
  {
    value: 'settings.ios_settings.csr_profile',
    class: 'w-[140px] text-ellipsis overflow-hidden whitespace-nowrap',
  },
  { value: 'settings.ios_settings.created_by', class: 'w-[180px]' },
  { value: 'settings.ios_settings.expiry_date', class: 'w-[100px]' },
  { value: '', class: 'w-16' },
];

export const WDA_TABLE_HEADERS = [
  { value: 'settings.ios_settings.wda.name', class: 'w-[150px]' },
  { value: 'settings.ios_settings.wda.wda', class: 'w-[150px]' },
  { value: 'settings.ios_settings.wda.created.by', class: 'w-[150px]' },
  { value: 'settings.ios_settings.wda.times.used', class: 'w-[200px]' },
  { vlaue: '', class: 'w-16' },
];

export const WDA_PROFILES_INFINITE_QUERY_KEY = 'wda-profiles-infinite-query';
export const PROVISIONING_PROFILES_INFINITE_QUERY_KEY =
  'provisioning-profiles-infinite-query';

export const IOS_SETTINGS_UPLOAD_ERRORS = {
  profileDeviceConflictsErrorCode: '409',
  profileDeviveMissingErrorCode: '226',
  profileCertificateMissingErrorText:
    'Certificate uploaded is not included in this provisioning profile.',
  invalidCertificateUploadedErrorText:
    'Invalid certificate uploaded, please upload a valid certificate.',
};

export const appleErrorHelpUrl =
  'https://developer.apple.com/library/archive/qa/qa1878/_index.html#:~:text=Q%3A%20What%20causes%20the%20provisioning,to%20it%20are%20marked%20Invalid.';
